<template>
  <footer>
    <div class="footer-container">
      <div class="app-container mb-4">
        <iframe
          src="https://xn----7sbgfh2alwzdhpc0c.xn--90ais/widget?pan=100059271&color=light"
          title="Качество услуг"
          width="300"
          height="130"
          frameborder="0"
          scrolling="no"
        />
      </div>
      <div class="app-container">
        <div class="links">
          <a
            class="banner-link"
            href="https://president.gov.by/ru/documents/ukaz-no-31-ot-17-anvara-2025-g"
            target="_blank"
          >
            <img
              class="banner-image"
              src="@/assets/pyatiletka-kachestva.jpg"
              alt="Пятилетка качества"
              width="468px"
              height="60px"
            />
          </a>
          <a
            href="https://www.government.by/news/pravitelstvo-utverdilo-respublikanskiy-plan-meropriyatiy-po-provedeniyu-v-2026-godu-goda"
          >
            <img src="../../assets/2026-god-bel-zhenschiny.jpg" alt="" />
          </a>

          <a href="http://xn----7sbgfh2alwzdhpc0c.xn--90ais/" target="_blank">
            <img src="../../assets/banner.jpg" alt="" />
          </a>
          <a href="http://mpt.gov.by/ru/" target="_blank">
            <img :src="getImage(1677)" alt="" class="img-filter" />
          </a>
          <a href="http://portal.gov.by/" target="_blank">
            <img :src="getImage(1)" alt="" class="img-filter" />
          </a>
          <a href="https://www.reestr-zalogov.by/" target="_blank">
            <img src="../../assets/reestr_imush.png" alt="" />
          </a>
          <a
            href="http://mininform.gov.by/documents/respublikanskiy-spisok-ekstremistskikh-materialov/"
            target="_blank"
          >
            <img
              src="../../assets/mpt-gov-by-banner-spisok-em-rb_1.jpg"
              alt=""
            />
          </a>
          <a href="https://nbbexpo.by/" target="_blank">
            <img src="../../assets/nbbexpo-banner.png" alt="" />
          </a>
        </div>
      </div>

      <div class="app-container flex-container flex-md-row">
        <div class="content mb-md-0 mb-3">
          <div class="logo">
            <app-image
              v-if="false"
              :id="142"
              name="ИППС"
              backgroundColor="#ffffff00"
            />
          </div>
          <p>© {{ $t('meta.footer.copyright') }}</p>
        </div>
        <social-links />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

import { getImage } from '@/api/index';
import AppImage from '@/components/AppImage/index.vue';
import SocialLinks from '@/components/SocialLinks';

export default {
  name: 'Footer',

  components: {
    AppImage,
    SocialLinks,
  },

  computed: {
    ...mapState({
      locale: (state) => state.app.locale,
    }),
  },

  methods: {
    getImage(id) {
      return getImage(id);
    },
  },
};
</script>

<style lang="stylus" scoped>
.mb-4 {
  margin-bottom: 16px;
}

footer {
  margin: auto 0 0;
  themify(
    $themes,
    @($theme) {
    background: $theme.$background--footer--color;
    border-top: 2px solid $theme.$secondary--dark--color;
  }
  );

  .widget {
    margin-bottom: 16px;
  }

  .links-item {
    display: flex;
    align-items: flex-start;
    width: 100%;
    height: 100%;
  }

  .links-item {
    border-right: 1px solid #ffffff50;
  }

  .footer-container {
    padding: 30px 0;

    .flex-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    .content {
      display: flex;
      align-items: center;

      .logo {
        margin-right: 15px;

        img {
          width: 50px;
          height: 50px;
        }
      }

      p {
        themify(
          $themes,
          @($theme) {
          color: $theme.$primary--light--color;
        }
        );
      }
    }
  }
}

.links.links-large {
  justify-content: start;

  a {
    width: 728px;
    height: 90px;
    margin: 0 10px;
  }
}

.links {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 2rem;

  a {
    height: 96px;
    width: 200px;
    margin: 0 10px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
    themify(
      $themes,
      @($theme) {
      filter: $theme.$image--grayscale--filter;
    }
    );

    &.img-filter {
      themify(
        $themes,
        @($theme) {
        filter: $theme.$image--invert--filter;
      }
      );
    }
  }
}

.banners {
  display: flex;
  margin-bottom: 2rem;
}
</style>
